/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessItemResponse } from '../../models/process-item-response';

export interface GetProcessItem$Params {
  processId: string;
  processItemId: string;
}

export function getProcessItem(http: HttpClient, rootUrl: string, params: GetProcessItem$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessItemResponse>> {
  const rb = new RequestBuilder(rootUrl, getProcessItem.PATH, 'get');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.path('processItemId', params.processItemId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessItemResponse>;
    })
  );
}

getProcessItem.PATH = '/process/{processId}/item/{processItemId}';
